import script from "./Botoes.vue?vue&type=script&setup=true&lang=js"
export * from "./Botoes.vue?vue&type=script&setup=true&lang=js"

import "./Botoes.vue?vue&type=style&index=0&id=0f206fa6&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontendRegua\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f206fa6"]])

export default __exports__